<template>
  <div class="animated">
    <v-client-table
      :columns="columns"
      :data="data"
      :options="options"
      :theme="theme"
      id="sample-receive-table"
      class="w-100"
    >
      <span slot="pid" slot-scope="{ row }">
        <router-link :to="`/samples/${row.get('id')}`">
          {{ row.publicNumber() }}
        </router-link>
        <span>
          {{ row.get("receiving_id") ? `(${row.get("receiving_id")})` : null }}
        </span>
      </span>
      <span slot="identifier" slot-scope="{ row }">
        {{ row.get("identifier") }}
      </span>
      <span slot="actions" slot-scope="{ row }">
        <b-button
          v-if="row.get('receiving_id')"
          disabled
          variant="success"
          class="px-1 py-0 text-white"
          block
          @click="markReceived(row)"
        >
          <i class="fa fa-plus-circle" />
        </b-button>
        <b-button
          v-if="!row.get('receiving_id')"
          variant="success"
          class="px-1 py-0 text-white"
          block
          @click="markReceived(row)"
        >
          Receive Sample
        </b-button>
      </span>
    </v-client-table>
  </div>
</template>

<script>
import Vue from "vue";
import { ClientTable, Event } from "vue-tables-2";
import SampleCollection from "../../../collections/lab/SampleCollection";

Vue.use(ClientTable);

export default {
  name: "SampleReceiveTable",
  components: {
    ClientTable,
    Event,
  },
  props: {
    data_rows: {
      type: Array,
    },
    collection: {
      type: SampleCollection,
      default: () => null,
    },
    show_columns: {
      type: Array,
      default: () => ["pid", "identifier", "actions"],
    },
    filterable: {
      type: Array,
      default: () => ["pid", "identifier", "actions"],
    },
  },
  data() {
    return {
      columns: this.show_columns,
      data: this.collection.models,
      options: {
        headings: {
          pid: "Sample",
          actions: "Receive Samples",
        },
        sortable: ["pid", "identifier"],
        filterable: this.filterable,
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort",
        },
        pagination: {
          chunk: 5,
          edge: false,
          nav: "scroll",
        },
      },
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
    };
  },
  methods: {
    markReceived(sample) {
      this.$emit("markReceived", sample);
    },
    logSample(sample) {
      console.log(sample.id);
    },
  }
};
</script>
